module.exports = __webpack_public_path__ + "static/media/active-code.f3b9bd98.png";